<template>
  <div>
    <section class="content">
      <div class="row center-block">
        <div class="box">
          <div class="box-header">
            <!-- Create new user button -->
            <v-btn :loading="loading" color="secondary" @click="getUsers">Reload</v-btn>
          </div>
          <div class="box-body">
            <v-data-table
              :headers="headers"
              :items="users"
              :sort-by.sync="sortBy"
              item-key="igHandle"
              class="elevation-1"
            >
              <template v-slot:body="{items}">
                <tbody>
                  <tr v-for="item in items" :key="item.id">
                    <td class="text-xs-left">
                      <a
                        target="_blank"
                        v-bind:href="'https://instagram.com/' + item.instagramHandle"
                      >@{{ item.instagramHandle }}</a>
                    </td>
                    <td class="text-xs-left">{{ item.fullName }}</td>
                    <td class="text-xs-left">{{ item.email }}</td>
                    <td class="text-xs-left">{{ item.location }}</td>
                    <td class="text-xs-left">{{ item.createdAt }}</td>
                    <td class="justify-center layout px-0">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn text icon color="green" @click="approveOrReject(1, item.id)">
                            <v-icon v-on="on">done_outline</v-icon>
                          </v-btn>
                        </template>
                        <span>Approve</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            text
                            icon
                            color="deep-orange"
                            @click="approveOrReject(2, item.id)"
                          >
                            <v-icon v-on="on">not_interested</v-icon>
                          </v-btn>
                        </template>
                        <span>Reject</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
// import config from '@/config';
import moment from 'moment';
import userApis from './userAPIs';
export default {
  data: () => ({
    sortBy: 'name',
    fullPage: true,
    loader: null, // do approval or reject
    loading: false, // Load user
    selected: [],
    headers: [
      {
        text: 'Instagram Handle',
        align: 'left',
        value: 'instagramHandle'
      },
      { text: 'Fullname', align: 'center', value: 'fullName' },
      { text: 'Email', value: 'email', align: 'left' },
      { text: 'Location', value: 'location', align: 'left' },
      { text: 'Created At', value: 'createdAt', align: 'left' },
      { text: 'Actions', align: 'left', value: 'action' }
    ],
    users: []
  }),

  methods: {
    formatTime(value) {
      return moment(value).format('YYYY-MM-DD hh:mm:ss');
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.users.slice();
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    async getUsers() {
      try {
        let resp = await userApis.getNewUsers();
        const displayUsers = resp.users.map(user =>
          Object.assign({
            id: user.id,
            instagramHandle: user.igHandle,
            fullName: `${user.firstName} ${user.lastName}`,
            email: user.email,
            location: user.location,
            createdAt: this.formatTime(user.createdAt)
          })
        )
        console.log(displayUsers)
        this.users = displayUsers;
        this.loading = false;
        return;
      } catch (error) {
        this.loading = false;
        this.$swal({
          title: 'Error',
          text: 'Cannot load users',
          type: 'error'
        });
      }
    },
    async approveOrReject(action, userId) {
      try {
        this.showLoading();
        await userApis.approveOrReject(action, userId);
        await this.getUsers();
        this.hideLoading();
        return;
      } catch (error) {
        this.hideLoading();
        this.$swal({
          title: 'Error',
          text: 'Action failed. Try again later',
          type: 'error'
        });
      }
    },
    showLoading() {
      this.loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false
      });
    },
    hideLoading() {
      if (this.loader) this.loader.hide();
    }
  },
  created() {
    this.getUsers();
  }
};
</script>



// WEBPACK FOOTER //
// UnApprovedUser.vue?40ac3b09